class BlockCrossSellV2 extends HTMLElement {
  constructor() {
    super();
    this.splide = null;
    this.arrows = {
      left: null,
      right: null
    };
  }

  async connectedCallback() {
    await this.initSplide();
  }

  disconnectedCallback() {
    if (this.splide) {
      this.splide.destroy();
    }
  }

  async initSplide() {
    const container = this.querySelector('.splide');
    if (!container) return;

    await ResourceCoordinator.requestVendor('Splide');

    this.splide = new Splide(container, this.getSplideOptions());
    this.splide.mount();

    this.arrows.left = this.querySelector('.splide__arrows .splide__arrow--prev');
    this.arrows.right = this.querySelector('.splide__arrows .splide__arrow--next');

    this.splide.on('pagination:updated', this.handlePaginationUpdate.bind(this));
  }

  getSplideOptions() {
    return {
      arrows: true,
      destroy: false,
      pagination: true,
      padding: { right: '24px' },
      perPage: 1,
      perMove: 1,
      gap: '8px',
      mediaQuery: 'min',
      breakpoints: {
        768: {},
      },
    };
  }

  handlePaginationUpdate(data) {
    if (data.items.length <= 0) return;

    const [firstItem, lastItem] = [data.items[0], data.items[data.items.length - 1]];
    const [isOnFirstPage, isOnLastPage] = [firstItem, lastItem].map(item => item.button.classList.contains('is-active'));

    this.setArrowVisibility(this.arrows.left, !isOnFirstPage);
    this.setArrowVisibility(this.arrows.right, !isOnLastPage);
  }

  setArrowVisibility(arrow, isVisible) {
    if (arrow) {
      arrow.classList.toggle('invisible', !isVisible);
    }
  }
}

customElements.define('block-cross-sell-v2', BlockCrossSellV2)

class BlockCrossSellV2Item extends HTMLElement {
  constructor() {
    super()
    this.props = {
      title: '',
      subtitle: '',
      image: '',
      handle: '',
    }
  }

  connectedCallback() {
    this.initProps()
    this.initEventListeners()
  }

  initProps() {
    this.props = {
      title: this.getAttribute(':title'),
      subtitle: this.getAttribute(':subtitle'),
      image: this.getAttribute(':image'),
      handle: this.getAttribute(':handle'),
    }
  }

  initEventListeners() {
    this.querySelector('variant-selector')?.addEventListener('change', this.refreshPrice.bind(this))
    this.querySelector('cross-sell-drawer-button').handleOpenCrossSellDrawerFunction = this.handleCrossSellDrawerOpen.bind(this)
    this.querySelector('button[name="add"]')?.addEventListener('click', this.handleAddToCart.bind(this))
  }

  handleCrossSellDrawerOpen() {
    window.eventBus.publish('cross-sell-drawer:open', {
      title: this.props.title.replace(' - BambooWeave', ''),
      subtitle: this.props.subtitle,
      drawerDescription: this.shadowRoot.querySelector('cross-sell-drawer-description').innerHTML,
      image: this.props.image,
      link: '/products/' + this.props.handle,
      primaryButton: {
        text: 'Add to Cart',
        onClick: (state, closeDrawer) => {
          this.handleAddToCart();
          // Perform add to cart operation
          closeDrawer(); // Close the drawer if needed
        }
      },
      secondaryButton: {
        text: 'View Product',
        onClick: (state, closeDrawer) => {
          window.open(state.link, '_blank');
          closeDrawer(); // Close the drawer if needed
        }
      }
    });
  }

  async handleAddToCart() {
    this.querySelector('button[name="add"]').setAttribute('disabled', 'disabled')
    this.querySelector('button[name="add"] svg[name="plus"]').classList.add('hidden')
    this.querySelector('button[name="add"] svg[name="spinner"]').classList.remove('hidden')

    const id = this.querySelector('variant-selector option:checked').value
    const sections = this.getSectionsToRender().map(section => section.section)
    const sectionUrl = window.location.pathname
    const { data: response } = await cartService.addSingle(id, sections)
    const { isGWP, state: cartWithGiftResponse } = await updateCartGift({ sections, sectionUrl })
    this.renderContents(isGWP ? cartWithGiftResponse : response)
    document.querySelector('cart-drawer').classList.remove('is-empty')
    document.querySelector('cart-drawer').open()


    this.querySelector('button[name="add"]').removeAttribute('disabled')
    this.querySelector('button[name="add"] svg[name="plus"]').classList.remove('hidden')
    this.querySelector('button[name="add"] svg[name="spinner"]').classList.add('hidden')
  }

  getSectionsToRender() {
    return [
      {
        id: "CartDrawerItems",
        section: "cart-drawer-items",
        selector: "#CartDrawer-CartItems",
      },
      {
        id: "shopify-section-cart-drawer-summary",
        section: "cart-drawer-summary",
        selector: ".cart-drawer-summary-wrapper",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".cart-icon-bubble",
      },
      {
        id: "shopify-section-cart-drawer-upsell",
        section: "cart-drawer-upsell",
      },
      {
        id: "shopify-section-cart-drawer-header",
        section: "cart-drawer-header",
        selector: ".drawer-header",
      },
    ];
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector,
      )
    })
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  refreshPrice() {
    const selectedOption = this.querySelector('variant-selector option:checked')
    const pricingEl = this.querySelector('.upsell-item__pricing')

    const price = Number(selectedOption.dataset.price)
    const originalPrice = Number(selectedOption.dataset.originalPrice)
    const priceInCurrency = price.toLocaleString();
    const originalPriceInCurrency = originalPrice.toLocaleString();

    pricingEl.innerHTML = html`
      <div class="${(originalPrice > price) ? 'text-[#F03306]' : ''} font-semibold">${priceInCurrency}원</div>
      ${(originalPrice > price) ? `<div class="text-[#2E2F3C] line-through">${originalPriceInCurrency}원</div>` : ''}
    `
  }

  handleMainProductVariantChange(mainProductVariant) {
    const selectedOptions = [...this.querySelectorAll('variant-selector option')]
    const mainProductVariantSize = mainProductVariant.title.split('|')[0].trim().toLowerCase()
    const matchedVariantSize = selectedOptions.find(o => o.text.split('|')[0].trim().toLowerCase() === mainProductVariantSize)
    if (matchedVariantSize) this.querySelector('variant-selector').selectVariant(matchedVariantSize.value)
  }
}

customElements.define('block-cross-sell-v2-item', BlockCrossSellV2Item)

